module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showModal1) ? _c('div', {
    staticClass: "remind"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('img', {
    staticClass: "back",
    attrs: {
      "src": require("../../images/contract-signature/back.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.showModal1 = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("尊敬的客户，您好：")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._v("\n        为了更好的保护您的账户安全、健全个人账户功能，同时响应最新的《个人信息安全规范》，请"), (!_vm.overdue) ? _c('span', [_vm._v("在"), _c('span', {
    staticClass: "date font-c"
  }, [_vm._v(_vm._s(_vm.date))]), _vm._v("前")]) : _vm._e(), _vm._v("完成实名认证。您的个人信息将得到绝对的保护。\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "decs font-c"
  }, [_vm._v("温馨提示：如实名认证过程中存在特殊情况，可联系您的专属客服进行解决")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('div', {
    class: _vm.overdue ? 'btn ccc' : 'btn',
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("暂不认证")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn1",
    on: {
      "click": _vm.contract
    }
  }, [_vm._v("去认证")])])])]) : _vm._e(), _vm._v(" "), _c('registerModal', {
    ref: "registerModalDom"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dec"
  }, [_c('img', {
    staticClass: "zhu",
    attrs: {
      "src": require("../../images/contract-signature/zhu.png")
    }
  }), _vm._v("\n      e签宝向您提供实名认证服务并承担责任。\n    ")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-04b6ad87", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04b6ad87"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":false}!./src/components/new-register/remind.vue
// module id = 1296
// module chunks = 61